import React from 'react'
import { gsap } from 'gsap'
import HighlightText from '../components/HighlightText'
import { useMedia } from 'react-use'
import globals from "../globals";

const BannerMobile = (props) => {
    const isDesktop = useMedia('(min-width: 1024px)')

    const scrollTo = (event) => {
        event.preventDefault()
        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: document.querySelector('.terms-anchor'),
                offsetY: 140
            }
        })
    }

    return (
        <div className='hero-banner-mobile'>
            <div className='mobile-spacer' />
            <div>
                <div className='row'>
                    <div className='col-12 col-xl-8 col-lg-10 px-4 px-lg-0 banner-content-container'>
                        <p className='m-0 mb-3 font-large semi-bold'>
                            SIM-only mobile plans
                        </p>
                        <h1 className='m-0 mb-2 mb-lg-4 d-inline-block'>
                            <HighlightText>No lock-in </HighlightText> 4G & 5G <br className="d-none d-md-inline" />mobile plans with <br className="d-none d-md-inline" />data rollover
                        </h1>
                        {isDesktop
                            ? <div>
                                <div className='d-flex mobile-list mb-5'>
                                    <img
                                        src='/images/hand-money-icon.svg'
                                        alt='voip-svg'
                                    />
                                    <p className='m-0 font-large semi-bold color-indigo'>
                                        Great value. Bundle internet for bigger
                                        savings
                                    </p>
                                </div>
                                <div className='d-flex mobile-list mb-5'>
                                    <img
                                        src='/images/mobile-banner-icon.svg'
                                        alt='voip-svg'
                                    />
                                    <p className='m-0 font-large semi-bold color-indigo'>
                                        Unlimited national calls & text
                                    </p>
                                </div>
                                <div className='d-flex mobile-list mb-5'>
                                    <img
                                        src='/images/man-mobile-icon.svg'
                                        alt='voip-svg'
                                    />
                                    <p className='m-0 font-large semi-bold color-indigo'>
                                        Prepaid with auto-recharge
                                    </p>
                                </div>
                              </div>
                            : <div>
                                <ul className='mobile-list-plans'>
                                    <li>
                                        <p className='m-0 font-smaller color-indigo'>
                                            Great value. Bundle internet for bigger
                                            savings
                                        </p>
                                    </li>
                                    <li>
                                        <p className='m-0 font-smaller color-indigo'>
                                            Unlimited national calls & text
                                        </p>
                                    </li>
                                    <li>
                                        <p className='m-0 font-smaller color-indigo'>
                                            Prepaid with auto-recharge
                                        </p>
                                    </li>
                                </ul>
                              </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BannerMobile



// WEBPACK FOOTER //
// ./resources/js/banners/BannerMobile.js